import 'vite/modulepreload-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import WooltariCupGame from '@/components/WooltariCup/WooltariCupGame';

const rootElement = document.getElementById('wooltari-cup');
if (rootElement) {
  const gameName = rootElement.getAttribute('data-game-name');
  const customerId = rootElement.getAttribute('data-customer-id');
  const email = rootElement.getAttribute('data-customer-email');
  const eventName = rootElement.getAttribute('data-event-name');
  const eventHandle = rootElement.getAttribute('data-event-handle');
  const token = rootElement.getAttribute('data-token');

  // const articleId = "test"
  // const articleHandle = "test"

  const gameStartInstruction = rootElement.getAttribute('data-game-start-instruction');
  const articleUrl = rootElement.getAttribute('data-article-url');
  const shopHandle = rootElement.getAttribute('data-shop-handle');
  const locale = rootElement.getAttribute('data-locale');
  const themeColor = rootElement.getAttribute('data-theme-color');
  const btnTxtColor = rootElement.getAttribute('data-btn-txt-color');
  const eventEndsAt = rootElement.getAttribute('data-event-end');
  const coverImage = rootElement.getAttribute('data-cover-image');
  const coverImageMobile = rootElement.getAttribute('data-cover-image-mobile');
  const loginUrl = rootElement.getAttribute('data-login-url');
  const loginToPlay = rootElement.getAttribute('data-login-to-play');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <WooltariCupGame
        campaignName={gameName}
        customerId={customerId}
        email={email}
        articleId={eventName}
        articleHandle={eventHandle}
        articleUrl={articleUrl}
        shopHandle={shopHandle}
        locale={locale}
        themeColor={themeColor}
        btnTxtColor={btnTxtColor}
        eventEndsAt={eventEndsAt}
        coverImage={coverImage}
        coverImageMobile={coverImageMobile}
        gameStartInstruction={gameStartInstruction}
        loginUrl={loginUrl}
        loginToPlay={loginToPlay}
        token={token}
      />
    </React.StrictMode>,
  );
}